import Vue from "vue"
import store from "@/store"
import { check } from "@/utils/roles";

// Com esse método podemos usar o $can para verificar as permissões em qualquer componente.
// Exemplo de uso: <component v-if="$can('service:action:strict')" />
if (!Vue.prototype.$can) {
  Vue.prototype.$can = (action, policies) => check(policies || store.getters[`User/policies`], action)
}
